export default {"src":"/_next/static/media/dental-blue-ppo.429cb78c.svg","height":34,"width":118,"blurWidth":0,"blurHeight":0};